export const NOTIFICATION_ELE_TAG = 'descope-notification';
